
export class Shifter {
    constructor(element) {
        this.element = typeof (element) === 'string' ? document.querySelector(element) : element;
        this.container = this.element.querySelector('.shift-block');
        this.level = 0;
        this.activeLayers = [];
        
    }

    init() {
        this.testNode = this.element.querySelector('.shifter-group:nth-child(2)');
        this.backLink = this.element.querySelector('.back');
        this.backLink.addEventListener('click', this.back.bind(this));
        this.toStartLink = this.element.querySelector('.back-to-start');
        this.toStartLink.addEventListener('click', this.backToStart.bind(this));
        Array.from(this.element.querySelectorAll('.has-children')).forEach(link => {
            link.addEventListener('click', function(event) {
                event.preventDefault();
                this.loadNext(link.getAttribute("group-id"));
            }.bind(this))
        })
    }

    back(event) {
        event.preventDefault();
        this.backToLevel(this.level - 1);
    }

    backToStart(event) {
        event.preventDefault();
        this.backToLevel(0);
    }

    backToLevel(level) {
        if (!this._locked && level >= 0 && level < this.level) {
            this.animate(level);
        }
    }

    loadNext(id) {
        if (!this._locked) {
            var target = this.element.querySelector('#' + id);
            if (target) {
                target.classList.add('active');
                this.activeLayers.push(target);
                this.animate(this.level + 1, true)
            }
        }
    }

    animate(level, isForward) {
        if (this.testNode) {
            var styles = getComputedStyle(this.testNode);
            this.testNode.style.display = 'block';
            this.offset = parseInt(styles.marginLeft) + this.testNode.clientWidth;
            this.testNode.style.display = '';
        }
        this._locked = true;
        var self = this;
        var tl = gsap.timeline({
            onComplete: () => {
                self._locked = false;
                while (self.activeLayers.length > this.level) {
                    self.activeLayers.pop().classList.remove('active');
                }
            }
        })
            .addLabel('start');
        if (!isForward) {
            if (level === 0) {
                tl
                    .to(this.backLink, .3, { x: -20, autoAlpha: 0, pointerEvents: 'none' });
            }
            if (level < 2) {
                tl
                    .to(this.toStartLink, .3, { x: 20, autoAlpha: 0, pointerEvents: 'none' });
            }
        }
        tl
            .to(this.container, {
                duration: .6,
                x: -level * this.offset,
            }, 'start');
        if (isForward) {
            if (this.level === 0) {
                tl
                    .fromTo(this.backLink, .3, { x: -20 }, { x: 0, autoAlpha: 1, pointerEvents: 'initial' }, '-=.1')
            }
            if (level > 1 && this.level < 2) {
                tl
                    .fromTo(this.toStartLink, .3, { x: 20 }, { x: 0, autoAlpha: 1, pointerEvents: 'initial' }, '-=.1')
            }
        }
        this.level = level;
    }

    reset() {
        this.level = 0;
        this.activeLayers = [];
        gsap.set([this.backLink, this.toStartLink, this.container], { clearProps: 'all' });
    }
}